import { ContextualInfoButtonWithText } from "@/components/buttons/ContextualInfoButton";
import { HubFormItem } from "@/components/inputs/HubFormItem";
import { RiskBandsArchetypeSelector } from "@/components/layouts/RiskBandsArchetypeSelector";
import { RiskBandsBuildYearSelector } from "@/components/layouts/RiskBandsBuildYearSelector";
import { RiskBandsHeightAboveGroundSelector } from "@/components/layouts/RiskBandsHeightAboveGroundSelector";
import { LargeSiteSettingsValues } from "@/tools/create/lss-from-map/types";
import { RiskBandsArchetype } from "@/tools/risk-bands/types";
import { Col, Form, Row } from "antd";
import { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
interface LargeSiteSettingsProps {
  notice?: string;
  setRefs?: (refs: LargeSiteSettingsRefs) => void;
  values: LargeSiteSettingsValues;
  setValues: Dispatch<SetStateAction<LargeSiteSettingsValues>>;
}
export interface LargeSiteSettingsRefs {
  archetype: MutableRefObject<null>;
  buildYear: MutableRefObject<null>;
  heightAboveGround: MutableRefObject<null>;
}
export const LargeSiteSettings = ({
  notice,
  values,
  setRefs,
  setValues
}: LargeSiteSettingsProps) => {
  const {
    t
  } = useTranslation("terms");
  const archetypeRef = useRef(null);
  const buildYearRef = useRef(null);
  const heightAboveGroundRef = useRef(null);
  const handleArchetypeChange = (value: RiskBandsArchetype) => {
    setValues(v => ({
      ...v,
      archetype: value
    }));
  };
  const handleBuildYearChange = (source: string, amount: number) => {
    setValues(v => ({
      ...v,
      buildYear: {
        source,
        amount
      }
    }));
  };
  const handleHeightAboveGroundChange = (source: string, amount: number) => {
    setValues(v => ({
      ...v,
      heightAboveGround: {
        source,
        amount
      }
    }));
  };
  useEffect(() => {
    if (!setRefs) {
      return;
    }
    setRefs({
      archetype: archetypeRef,
      buildYear: buildYearRef,
      heightAboveGround: heightAboveGroundRef
    });
  }, [archetypeRef, buildYearRef, heightAboveGroundRef]);
  return <Form layout="vertical" className="[&_.ant-form-item-additional]:!min-h-5" data-sentry-element="Form" data-sentry-component="LargeSiteSettings" data-sentry-source-file="LargeSiteSettings.tsx">
      <Row gutter={[16, 0]} data-sentry-element="Row" data-sentry-source-file="LargeSiteSettings.tsx">
        {!!notice && <Col span={24} style={{
        marginBottom: "1rem"
      }}>
            <div className="max-w-[80%] pb-2 text-xs text-gray-500">{notice}</div>
          </Col>}
        <Col ref={archetypeRef} span={24} data-sentry-element="Col" data-sentry-source-file="LargeSiteSettings.tsx">
          <HubFormItem label={<ContextualInfoButtonWithText id="archetypesExplained" drawerWidth={750}>
                {t("assetArchetype")}
              </ContextualInfoButtonWithText>} data-sentry-element="HubFormItem" data-sentry-source-file="LargeSiteSettings.tsx">
            <RiskBandsArchetypeSelector archetype={values.archetype || ""} onChange={handleArchetypeChange} data-sentry-element="RiskBandsArchetypeSelector" data-sentry-source-file="LargeSiteSettings.tsx" />
          </HubFormItem>
        </Col>

        <Col ref={buildYearRef} span={24} data-sentry-element="Col" data-sentry-source-file="LargeSiteSettings.tsx">
          <HubFormItem label={<ContextualInfoButtonWithText id="buildYear">{t("buildYear")}</ContextualInfoButtonWithText>} data-sentry-element="HubFormItem" data-sentry-source-file="LargeSiteSettings.tsx">
            <RiskBandsBuildYearSelector archetype={values.archetype || ""} buildYear={values.buildYear} onChange={handleBuildYearChange} data-sentry-element="RiskBandsBuildYearSelector" data-sentry-source-file="LargeSiteSettings.tsx" />
          </HubFormItem>
        </Col>
        <Col ref={heightAboveGroundRef} span={24} data-sentry-element="Col" data-sentry-source-file="LargeSiteSettings.tsx">
          <HubFormItem label={<ContextualInfoButtonWithText id="heightAboveGround">
                {t("heightAboveGround")}
              </ContextualInfoButtonWithText>} data-sentry-element="HubFormItem" data-sentry-source-file="LargeSiteSettings.tsx">
            <RiskBandsHeightAboveGroundSelector archetype={values.archetype || ""} heightAboveGround={values.heightAboveGround} onChange={handleHeightAboveGroundChange} data-sentry-element="RiskBandsHeightAboveGroundSelector" data-sentry-source-file="LargeSiteSettings.tsx" />
          </HubFormItem>
        </Col>
      </Row>
    </Form>;
};